import React from "react";
import "../styles/ContactUs.css";

function ContactUs() {
  return (
    <section id="contact" className="contact-section">
      <div className="section-container contact-container">
        
        {/* Left side: Title + details */}
        <div className="contact-details">
          <h2>Contact Us</h2>
          <p>Email: legalservices@nyayom.com</p>
          <p>Phone: +91-9819288998</p>
          <p>Address: C/401 Shree Highland Park, New Link Road, Dahanukarwadi, Kandivali West. Mumbai- 400067. Maharashtra. India.</p>
        </div>

        {/* Right side: Form */}
        <div className="contact-form">
          {/* Embed Google Form */}
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdUzTw2z2Sn1EVhvqcXli-J3CuhVmaK1SLkUoqD3HsWhCj8Pw/viewform?embedded=true" width="100%" title="Contact Us" >
            Loading…
          </iframe>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
